import { withTheme } from '@emotion/react'
import React from 'react'

const GlobalStyles = withTheme(() => <></>)

export default GlobalStyles
